module.exports = __webpack_public_path__ + "img/file-ruled.44f373ba.svg";